export class User {
	additionalNotificationEmails: any[];
	allowCartCheckout: boolean;
	allowMapValidation: any;
	allowRecentOrders: boolean;
	allowRecentTemplates: boolean;
	allowedCustomers: any[];
	allowZeroPiecesOnOrders: boolean;
	approved: boolean;
	associatedDrivers: any[];
	canViewDriverPhoto: boolean; // not used in RS is same as displayDriverPhoto under globalSettings
	canViewOwnProfile: boolean;
	cancelOrderOption: string;
	companyName: string;
	customerName: string;
	cxtId: number;
	defaultCountry: string;
	defaultDestinationAddressId: number;
	defaultOriginAddressId: number;
	defaultServiceType: any;
	driverId: number;
	editOrderValue: string;
	email1: string;
	fieldSpecifications: [
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		},
		{
			name: string;
			required: boolean;
			min: number;
			max: number;
			defaultEntry: string;
			overrideLabel: string;
		}
	];
	firstName: string;
	friendlyName: string;
	globalSettings: {
		allowGuest: boolean;
		contactlessServiceRapidship: boolean;
		creditCardProcessingMethod: string;
		useCanadianAddressesByDefault: boolean;
		enableGooglePlacesSearch: boolean;
		enforceAddressValidation: boolean;
		allowUnknownDest: boolean;
		requirePiecesForOrders: boolean;
		requireWeightForOrders: boolean;
		defaultPieceCountForOrders: any;
		defaultWeightAmountForOrders: any;
		requireParcelTypeForOrders: boolean;
		customMessageForNullPickedup: string;
		customMessageForNullDelivered: string;
		displayAddressesOnOrderTrackingPage: boolean;
		dateFormat: string;
		timeDisplayFormat: string;
		inetMaxAttachmentSize: number;
		displayDriverPhoto: boolean;
		displayInvoices: boolean;
		displayReleaseInfo: boolean;
		customZipCodeNotFoundError: string;
		canCreateCustAccount: boolean;
		canCreateUserLogin : boolean;
		displayETA: boolean;
		releaseInfoLabel: string;
		isParcelEntryEnabled: boolean;
		isTextMessagingEnabled: boolean;
		driverLocationDisplayAccessibility: string;
		isQuickbooksEnabled: boolean;
		isPackageInfoRequired: boolean;
		isCentralizedSsoConfigured: boolean;
		ssoDomains: string[];
		trackingOptions: {
			isActive: boolean;
		};
		requirePhoneNumberClientPortal: boolean;
	};
	hideDeliverBy: boolean;
	hideItems: boolean;
	/**
	 * True when THIS SESSION was authenticated through SSO. Client-side only — not a server contract.
	 *
	 * There is no per-user or per-session SSO marker anywhere: SSO-ness is decided at login by splitting the
	 * typed username on '@' and matching the domain against globalSettings.ssoDomains. So it is a property of
	 * the session, not of the user — the same account can sign in either way if its domain is SSO-configured,
	 * which is why this must not be re-derived from ssoDomains later.
	 *
	 * Persisted with the session (localStorage 'Rapidship:user') so it survives a page refresh, and reset by
	 * the `new User()` in loginInitiationSuccess so a later password login cannot inherit it.
	 */
	isSsoSession: boolean;
	inetUser: {
		allowPlaceOrders: boolean;
		allowTrackOrder: boolean;
		id: string;
		custId: any;
		email: string;
		phone: string;
		friendlyName: string;
		hideRates: boolean;
		addressBookOnDemand: boolean;
		canViewShippingOptions: boolean;
		defaultServiceType: string;
		defaultBillingGroup: string;
		defaultReportType: string;
		accessorialCharges: boolean;
		allowDueTimeFrom: boolean;
		viewInvoices: boolean;
		addressBookLocked: boolean;
		billingGroupLocked: boolean;
		defaultpointIdOrigin: string;
		defaultpointIdDest: string;
		userAddressBookEnabled: boolean;
		useConsolidatedAddresses: boolean;
		addressBookGroup: string;
		shippingLabelId: any;
		routeShippingLabelId?: number;
		routeStopShippingLabelId?: number;
		routeParcelShippingLabelId?: number;
		viewRouteStops: boolean;
		miscData: any;
		modifyRouteStops: boolean;
		modifyRouteStopParcels: boolean;
		viewAccountReports: boolean;
		viewDetailTracking: boolean;
		creditCardUsage: any;
		allowPasswordChange: boolean;
		allowAddressBookAccess: boolean;
		filterInetUserDrivers: boolean;
		hideInactiveRouteStops: boolean;
		allowRateOverride: boolean;
		printShippingLabel: boolean;
		defaultAddressSearch: string;
		pushNotifications: {
			confirmed: boolean;
			arrived: boolean;
			pickedUp: boolean;
			delivered: boolean;
			eta: boolean;
		};
		defaultOrderTypeId: number;
		followCustomerOrderType: boolean;
		driverLocationDisplayAccessibility: string;
	};
	lastName: string;
	licenses: {
		xRouteEnabled: boolean;
	};
	localOffset: any;
	maxAttachmentSize: number;
	mobilePhone: string;
	parcelTypes: string;
	preferredDistanceUnit: string;
	primaryCustomerId: number;
	serviceTypes: [
		{
			id: number;
			description: string;
		}
	];
	showAddresses: boolean;
	showBaseAmount: boolean;
	showDriverSplit: boolean;
	showGroup: boolean;
	showNames: boolean;
	showOrderType: boolean;
	showPercentOrder: boolean;
	showPieces: boolean;
	showPrice: boolean;
	showReference: boolean;
	showTotalsOnly: boolean;
	showWeight: boolean;
	showZip: boolean;
	token: string;
	type: string;
	useConsolidatedAddresses: boolean;
	/** A string for inet users; a number for workers (AuthenticationService.loginWorker parses it). */
	username: string | number;
	validateInetAddresses: boolean;
	featureFlags: any = {};
	emailVerified: boolean;
	customerMfaPolicy: number;
	mfaEnrolledMethodCount: number;
	mfaMode: number;
	mfaGracePeriodStartedAt: string;
	mfaWizardSkipped: boolean;
	mfaEnrollmentPending: boolean;
	mfaChallengePending: boolean;
	mfaChallengeSessionId: string;
	mfaPreferredMethod: string;
	mfaAvailableMethods: string[];
	mfaMaskedEmail: string;
	mfaOtpTtlMinutes: number;
	mfaOtpResendDelaySeconds: number;
	mfaMaxAttempts: number;
	mfaContactAdminPhone: string;
	mfaContactAdminEmail: string;
	mfaNotifyPending: boolean;
	mfaDisabledMethodNames: string[];
	mfaEffectivePolicy: number;
	mfaGracePeriodActive: boolean;
	mfaGracePeriodDaysRemaining: number;
	mfaAllowedMethodsForEnrollment: string[];
}

/**
 * A worker's username is stored as a number (AuthenticationService.loginWorker), so string methods on
 * `user.username` throw for a worker. Go through this when a string is needed. A missing username stays missing.
 */
export function usernameAsString(user: Pick<User, 'username'> | null | undefined): string | undefined {
	const name = user?.username;
	return name == null ? undefined : String(name);
}
